<template>

  <v-card
    max-width="205"
  >
      <v-card-text class="justify-end mb-n4" style="font-size:1.0em" >
        Queued Email(s)
      </v-card-text>

      <v-card-text>
          <div class ="text-end font-weight-bold" style="font-size:1.0em">
            {{ queued }}
          </div>
      </v-card-text>

  </v-card>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'QueuedEmail',
  computed: {
    ...mapGetters({
      queued: 'count_queued'
    })
  }
}
</script>
